export class WindowRef {

  public getNativeWindow(): any {
    return window;
  }

}
